export const NEW_USER = () => {
    return {
        id: 0,
        name: '',
        surname: '',
        password: 'password',
        password_confirm: '',
        active: 1,
        role: '',
        additional_vacation_days: 0,
        allow_weekend_vacation: 0,
        profile: {}
    }
}

export const NEW_ARTICLE = () => {
    return {
        id: 0,
        title: '',
        subtitle: '',
        category_id: null,
        published: false,
        urgent: false,
        body: '',
        image: '',
    }
}

export const NEW_DOCUMENT = () => {
    return {
        id: 0,
        title: '',
        category_id: null,
        image: '',
    }
}

export const NEW_ARTICLE_CATEGORY = () => {
    return {
        id: 0,
        title: ''
    }
}

export const NEW_COMPANY_EQUIPMENT = () => {
    return {
        id: 0,
        title: '',
        identifier: false
    }
}

export const NEW_USER_EQUIPMENT = () => {
    return {
        id: 0,
        issued: false,
        identifier: ''
    }
}

export const NEW_LOAD = () => {
    return {
        id: 0,
        vehicles: [],
        from: null,
        to: null,
    }
}
export const NEW_COMPANY = () => {
    return {
        id: 0,
        title: '',
        active: 1,
    }
}

export const NEW_COMMITTEE = () => {
    return {
        id: 0,
        title: '',
        parent_id: null,
    }
}

export const NEW_COOKIE = () => {
    return {
        id: 0,
        title: '',
    }
}